import React, { useEffect, useState } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import { Button, Grid, IconButton, Link, Typography } from '@material-ui/core';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import { MessageValues } from '../../values/MessageValues';


const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  }
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%'
  },
  grid: {
    height: '100%'
  },
  quoteContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  quote: {
    backgroundColor: theme.palette.neutral,
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/auth03.jpeg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',

  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: theme.palette.white,
    fontWeight: 300
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.white
  },
  bio: {
    color: theme.palette.white
  },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  logoImage: {
    marginLeft: theme.spacing(4)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  socialButtons: {
    marginTop: theme.spacing(3)
  },
  socialIcon: {
    marginRight: theme.spacing(1)
  },
  sugestion: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  },
  logo: {
    padding: theme.spacing(5),
    marginTop: '10%',
    marginLeft: '10%'
  }
}));

const SignIn = props => {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const { history } = props;
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');

  const classes = useStyles();

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);


  const handleSignIn = async event => {
    event.preventDefault();
    try{
      setLoading(true);
      let info = {
        login: login,
        senha: senha
      };
      let auth = await api.post('/authenticate/', info);
      if(auth){
        if(auth.data.isSuccess){
          setLoading(false);
          await localStorage.clear();
          await localStorage.setItem('auth', JSON.stringify(auth.data));
          await localStorage.setItem('modoAnonimo', 'true');
          history.push('/dashboard');
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack(auth.data.message);
          setShowMessageSnack(true);
        }
      }
      else{
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Ocorreu um erro no processamento da requisição.');
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
      setShowMessageSnack(true);
    }
  };

  const handleClickShowPassword = () => {
    setMostrarSenha(!mostrarSenha);
  };

  return (
    <div className={classes.root}>
      <ProgressFullScreen
        open={loading}
        setOpen={setLoading}
      />
      <SnackbarCustom
        verticalOrientation='bottom'
        horizontalOrientation='center'
        open={showMessageSnack}
        setOpen={setShowMessageSnack}
        message={messageSnack}
        duration={2000}
        type={typeSnack}
      />
      <Grid
        className={classes.grid}
        container
      >
        <Grid
          className={classes.quoteContainer}
          item
          lg={6}
        >
          <div className={classes.quote}>

          </div>
        </Grid>
        <Grid
          className={classes.content}
          item
          lg={6}
          xs={12}
        >
          <div className={classes.content}>
            <div className={classes.contentBody}>
              <ValidatorForm
                className={classes.form}
                autoComplete="off"
                onSubmit={handleSignIn}
              >
                <Typography
                  className={classes.title}
                  variant="h2"
                >
                  Login
                </Typography>
                <Typography
                  align="center"
                  className={classes.sugestion}
                  color="textSecondary"
                  variant="body1"
                >
                  Entre com seu login ou email
                </Typography>
                <TextValidator
                  fullWidth
                  label="Login ou email"
                  helperText="Insira o login ou email do usuário."
                  margin="dense"
                  name="login"
                  onChange={e => setLogin(e.target.value)}
                  value={login}
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Insira o login ou email do usuário.']}
                />
                <TextValidator
                  id="outlined-adornment-password"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  value={senha}
                  type={mostrarSenha ? 'text' : 'password'}
                  label="Informe a senha"
                  onChange={e => setSenha(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {mostrarSenha ? <VisibilityOff/> : <Visibility/>}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  helperText="Insira a senha de acesso ao sistema do usuario."
                  validators={['required']}
                  errorMessages={['Informe a senha']}
                />
                <Button
                  className={classes.signInButton}
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Entrar
                </Button>

                <Typography
                  color="textSecondary"
                  variant="body1"
                >
                  Esqueceu sua senha?{' '}
                  <Link
                    component={RouterLink}
                    to="/recuperacao-senha"
                    variant="h6"
                  >
                    Clique aqui
                  </Link>
                </Typography>
              </ValidatorForm>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

SignIn.propTypes = {
  history: PropTypes.object
};

export default withRouter(SignIn);
